module.exports = __webpack_public_path__ + "static/background-video-31931c1a014c23262a851c53b07ded63.mp4";